<template>
  <div>

    <!-- PRINT -->

    <div class="container">
      <no-ssr>
        <carousel
          :autoplay="true"
          :loop="true"
          :pagination-enabled="false"
          :per-page-custom="[
            [0, 1],
            [576, 2],
            [992, 4],
            [1400, 4],
          ]"
          :speed="1000"
          :autoplay-timeout="5000"
          class="highlights"
        >
          <slide>
            <div class="highlight highlight--delivery">
              <cms-block-chunk :identifier="'c_CERTYFIKOWANA_JAKOSC'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight--return">
              <cms-block-chunk :identifier="'c_BEZTERMINOWA_GWARANCJA'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight--warranty">
              <cms-block-chunk :identifier="'c_ZWIEKSZONA_WYDAJNOSC'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight--security">
              <cms-block-chunk :identifier="'c_PEWNOSC_BEZPIECZENSTWO'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
        </carousel>
      </no-ssr>
    </div>

    <!-- OFFICE -->

    <!-- <div class="container" v-show="toggleChank">
      <no-ssr>
        <carousel
          :autoplay="true"
          :loop="true"
          :pagination-enabled="false"
          :per-page-custom="[
            [0, 1],
            [576, 2],
            [992, 4],
            [1400, 4],
          ]"
          :speed="1000"
          :autoplay-timeout="5000"
          class="highlights"
        >
          <slide>
            <div class="highlight highlight">
              <cms-block-chunk :identifier="'c_CERTYFIKOWANA_JAKOSC_2'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight">
              <cms-block-chunk :identifier="'c_BEZTERMINOWA_GWARANCJA_2'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight">
              <cms-block-chunk :identifier="'c_ZWIEKSZONA_WYDAJNOSC_2'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
          <slide>
            <div class="highlight highlight">
              <cms-block-chunk :identifier="'c_PEWNOSC_BEZPIECZENSTWO_2'" default-value="<div class=&quot;h3 highlight__title&quot;> </div>" />
            </div>
          </slide>
        </carousel>
      </no-ssr>
    </div> -->
  </div>
</template>

<script>
import config from 'config';
import NoSSR from 'vue-no-ssr';
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk';
import { isServer } from '@vue-storefront/core/helpers';

const Carousel = () => import('vue-carousel').then(Slider => Slider.Carousel);
const Slide = () => import('vue-carousel').then(Slider => Slider.Slide);
export default {
  name: 'ShopInfo',
  data () {
    return {
      config,
    }
  },
  components: {
    Carousel,
    Slide, 
    'no-ssr': NoSSR,
    CmsBlockChunk
  },
  computed: {
    toggleChank () {
      if (!isServer && window && window.location.pathname.startsWith(config.site.office_path)) {
        return true
      } else {
        return false
      }
    }    
  }
};
</script>

<style lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
.shop-info {
  background: #2a0064;
}

.shop-office {
  background: $office-primary
}

.highlights {
  list-style: none;
  margin: 0 auto;
}

.highlight {
  color: #fff;
  position: relative;
  padding: 8px 10px 10px 40px;
  height: 22px;
  font-family: "Roboto", sans-serif;

  @media only screen and (max-width: 575px) {
    display: inline-block;
    text-align: left;
  }

  &__title, h1 {
    font-size: 16px;
    line-height: 24px;
    font-weight: normal;
    font-family: "Roboto", sans-serif;
    margin: 0;
  }

  &__text, p {
    font-size: 13px;
    line-height: 18px;
    font-family: "Roboto", sans-serif;
    margin: 0;
  }

  &:before {
    content: "";
    position: absolute;
    display: block;
    background-size: cover;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }

  &--delivery {
    padding: 10px 30px 10px 50px;

    &:before {
      background: url("/assets/icon1.svg") no-repeat;
      width: 26px;
      height: 28px;
      background-size: contain;
      left: 14px;
    }
  }

  &--return {
    &:before {
      background: url("/assets/icon2.svg") no-repeat;
      width: 46px;
      height: 16px;
      background-size: contain;
    }
  }
  &--warranty {
    &:before {
      background: url("/assets/icon3.svg") no-repeat;
      width: 26px;
      height: 26px;
      background-size: contain;
    }
  }
  &--security {
    &:before {
      background: url("/assets/icon4.svg") no-repeat;
      width: 26px;
      height: 26px;
      background-size: contain;
      left: 6px;
    }
  }
}
</style>